import { render, staticRenderFns } from "./Addrlist.vue?vue&type=template&id=21b387e4&scoped=true&"
import script from "./Addrlist.vue?vue&type=script&lang=js&"
export * from "./Addrlist.vue?vue&type=script&lang=js&"
import style0 from "./Addrlist.vue?vue&type=style&index=0&id=21b387e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b387e4",
  null
  
)

export default component.exports